export const TESTIDS = {
  header: {
    logo: "header-logo",
    navHome: "nav-home",
    navServices: "nav-services",
    navGallery: "nav-gallery",
    navAbout: "nav-about",
    navContact: "nav-contact",
    phoneCta: "header-phone-cta",
    mobileToggle: "header-mobile-toggle",
    mobilePanel: "header-mobile-panel",
  },
  hero: {
    root: "hero-root",
    logo: "hero-logo",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    slideDot: "hero-slide-dot",
  },
  services: {
    root: "services-root",
    card: "service-card",
  },
  gallery: {
    root: "gallery-root",
    item: "gallery-item",
  },
  contact: {
    form: "contact-form",
    name: "contact-name",
    phone: "contact-phone",
    email: "contact-email",
    service: "contact-service",
    address: "contact-address",
    message: "contact-message",
    submit: "contact-submit",
  },
  footer: {
    root: "footer-root",
  },
  admin: {
    loginForm: "admin-login-form",
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    logout: "admin-logout",
    filterAll: "admin-filter-all",
    filterNew: "admin-filter-new",
    filterContacted: "admin-filter-contacted",
    filterConverted: "admin-filter-converted",
    filterLost: "admin-filter-lost",
    export: "admin-export-csv",
    leadRow: "admin-lead-row",
    statusSelect: "admin-lead-status",
    delete: "admin-lead-delete",
  },
};

// Legacy - kept to avoid breaking App.js import expectations
export const HOME = { emergentLink: "emergent-link" };
